import LegalShell from "./LegalShell";

export default function Privacy() {
    return (
        <LegalShell
            title="Gizlilik Politikası"
            subtitle="Sayz hizmetlerinde kişisel verilerinizi nasıl koruduğumuzu, hangi amaçla kullandığımızı ve haklarınızı açıklar."
            lastUpdated="24 Şubat 2026"
            testId="legal-privacy"
        >
            <p className="lead">
                Sayz; e-ticaret siteleri için "Beden Tablosu" ve "Bedenimi Bul" widget'ları
                sunan kapalı devre bir B2B SaaS platformudur. Gizliliğiniz bizim için
                temel bir tasarım kuralıdır — veri minimizasyonu, amaca bağlılık ve
                şeffaflık ilkeleriyle çalışırız.
            </p>

            <h2>1. Toplanan Veriler</h2>
            <h3>Müşteri (Merchant) hesabı</h3>
            <ul>
                <li>E-posta adresi (giriş + bildirim)</li>
                <li>OTP doğrulama kodları (6 haneli, 10 dk geçerli)</li>
                <li>Site adresi (widget'ın yükleneceği domain)</li>
                <li>Panel ayarları: beden tablosu, model bilgileri, ürün eşleştirmeleri</li>
                <li>Fatura bilgileri (varsa)</li>
            </ul>

            <h3>Ziyaretçi (end-user) etkileşimleri</h3>
            <p>
                Merchant sitelerindeki widget'ın topladığı veriler <strong>anonim</strong>
                tutulur ve kimlik tespiti yapılamaz:
            </p>
            <ul>
                <li>Boy, kilo, yaş aralığı (Bedenimi Bul akışında girilen)</li>
                <li>Vücut tipi + fit tercihi</li>
                <li>Önerilen beden ve o ürün için satın alma sinyali (opsiyonel, merchant entegrasyonu)</li>
                <li>Tarayıcı ve cihaz tipi (teknik metrikler için)</li>
            </ul>
            <p>
                Smart Recall özelliği etkinleştirildiğinde ziyaretçinin kendi tarayıcısındaki{" "}
                <code>localStorage</code>'a profil bilgileri yazılır. Bu veri{" "}
                <strong>Sayz sunucularına aktarılmaz</strong>; sadece aynı ziyaretçi
                sonraki ürünlerde wizard'ı atlayabilmek için kullanılır. Kullanıcı
                çerezleri tarayıcıdan silerse veri kaybolur.
            </p>

            <h2>2. Verilerin Kullanım Amaçları</h2>
            <ul>
                <li>Hizmetin sunulması ve müşteri panelinin işletilmesi</li>
                <li>Hesap güvenliği (OTP, oturum doğrulama, dolandırıcılık önleme)</li>
                <li>Beden önerilerinin oluşturulması (nearest-neighbor RBF algoritması)</li>
                <li>Merchant'a özel aggregate analitik (yüksek seviyeli, kimlik içermez)</li>
                <li>Hizmet kalitesinin ve ürün geliştirmenin iyileştirilmesi</li>
                <li>Yasal yükümlülüklerin yerine getirilmesi</li>
            </ul>

            <h2>3. Üçüncü Taraf Paylaşımları</h2>
            <p>Verilerinizi aşağıdaki haller dışında kimseyle paylaşmayız:</p>
            <ul>
                <li><strong>Altyapı:</strong> AWS, Emergent Platform (barındırma)</li>
                <li><strong>E-posta:</strong> Transactional e-posta sağlayıcıları (yalnızca OTP, bildirim)</li>
                <li><strong>Hata izleme:</strong> Sentry (opsiyonel; anonim stack trace)</li>
                <li><strong>Yasal zorunluluk:</strong> yetkili yargı/kamu kurum talepleri</li>
            </ul>
            <p>
                Verilerinizi hiçbir koşulda reklam ağlarıyla, veri komisyoncularıyla veya
                başka firmalara satmayız/pazarlamayız.
            </p>

            <h2>4. Veri Güvenliği</h2>
            <ul>
                <li>TLS 1.3 uçtan uca şifreleme</li>
                <li>MongoDB üzerinde tenant_id tabanlı izolasyon (cross-tenant pytest ile doğrulanır)</li>
                <li>Her merchant için ayrı yedek (per-tenant snapshot engine)</li>
                <li>Destructive işlemlerde taze OTP yeniden doğrulama</li>
                <li>Toplu silme işlemlerinde "SIL" yazılı onay + superadmin approval mekanizması</li>
                <li>CSRF double-submit cookie koruması</li>
                <li>Tüm destructive işlemlerin denetim kaydı (audit log)</li>
            </ul>

            <h2>5. Veri Saklama</h2>
            <p>
                Kişisel verileri yalnızca gerekli olduğu süre boyunca tutarız:
            </p>
            <ul>
                <li>Aktif hesap bilgileri: sözleşme süresince</li>
                <li>Hesap kapandıktan sonra: ticari defter saklama süresine kadar (10 yıl)</li>
                <li>Audit log: 24 ay</li>
                <li>Widget etkileşim logu: 30 gün (sonra aggregate'e dönüşür)</li>
                <li>OTP kodu: 10 dakika</li>
                <li>Reauth token: 5 dakika</li>
            </ul>

            <h2>6. Çocuklara Yönelik Hizmet Sunulmaz</h2>
            <p>
                Sayz B2B bir hizmet olarak yalnızca kurumsal müşterilere sunulur ve
                18 yaş altındaki bireysel kullanıcılara yöneltilmez. Çocuklara ait kişisel
                veri bilerek toplanmaz.
            </p>

            <h2>7. Haklarınız</h2>
            <p>
                KVKK m.11 ile tanınan tüm haklara (bilgi alma, düzeltme, silme, itiraz, taşınabilirlik)
                sahipsiniz. Detaylar{" "}
                <a href="/legal/kvkk">KVKK Aydınlatma Metni</a> sayfasında yer alır.
            </p>

            <h2>8. Değişiklikler</h2>
            <p>
                Bu politikayı zaman zaman güncelleyebiliriz. Önemli değişiklikler için
                panel üzerinden ve e-posta ile bildirim göndeririz. Son güncelleme tarihi
                sayfanın başında belirtilmiştir.
            </p>

            <h2>9. İletişim</h2>
            <p>
                Gizlilikle ilgili tüm sorularınız için:{" "}
                <a href="mailto:hello@atamis.global">hello@atamis.global</a>
            </p>
        </LegalShell>
    );
}
